module.exports = __webpack_public_path__ + "static/media/whatsaap.bd79b7ef.JPG";